import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { BooleanInput } from '@angular/cdk/coercion';
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { select, Store } from '@ngrx/store';
import {
    LocalStorageService,
    LOCAL_STORAGE_KEY,
} from '@core/services/localstorage.service';
import { Router } from '@angular/router';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
})
export class UserComponent implements OnInit, OnDestroy {
    static ngAcceptInputType_showAvatar: BooleanInput;

    @Input() showAvatar: boolean = false;
    user: User;

    infoUser = new Observable();

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _userService: UserService,
        private store: Store,
        private localStorageService: LocalStorageService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.infoUser =
            this.store
                .pipe(select((v) => v))
                .pipe(map((v: any) => v.auth.user)) ||
            this.localStorageService.getObject(LOCAL_STORAGE_KEY.USER);

        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService
            .update({
                ...this.user,
                status,
            })
            .subscribe();
    }

    signOut(): void {
        this.router.navigate(['sign-out']);
    }
}
